// extracted by mini-css-extract-plugin
module.exports = {"link":"_93444fe79c--link--Kd7LB","link-simplified":"_93444fe79c--link-simplified--LftmI","title":"_93444fe79c--title--t0Ggq"};